<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="图片标题">
                    <el-input v-model="search.title" placeholder="请输入图片标题"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80"></el-table-column>
                <el-table-column prop="Title" label="说明" width></el-table-column>
                <el-table-column prop="FirstPng" label="首图" width>
                    <template scope="scope">
                        <span v-if="scope.row.FirstPngUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.FirstPngUrl" width="100%" />
                                <img slot="reference" :src="scope.row.FirstPngUrl" :alt="scope.row.FirstPngUrl"
                                    width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                  <el-table-column prop="IsVide" label="类型">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsVide==0 ? 'success' : 'success'" disable-transitions>{{
                            scope.row.IsVide==0 ? "视频" : "产品详情" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Sort" label="排序" width></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width></el-table-column>
                <el-table-column prop="Enabled" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Enabled==true ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.Enabled==true ? "启用" : "停用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template scope="scope">
                        <el-button size="small" type="primary" v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"   v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0" 
                            @click="handledel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>


                <!--修改界面-->
        <el-dialog title="数据修改" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                <el-form-item label="说明" prop="Title">
                    <el-input v-model="editForm.Title" type="Text" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="首图" prop="FirstPng">
                    <ImageFile :value="firtimgList" :imgLimit="1" @change="firtImageChange"></ImageFile>
                </el-form-item>
                <el-form-item label="品牌标识" prop="BrandType">
                    <selectPBBrand style="width: 100%" v-model="editForm.BrandType">
                    </selectPBBrand>
                </el-form-item>
                <el-form-item label="是否视频" prop="IsVide">
                    <el-radio-group v-model="editForm.IsVide">
                        <el-radio :label="0" checked>是</el-radio>
                        <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="视频链接" prop="VideUrl" v-if="editForm.IsVide==0">
                    <el-input v-model="editForm.VideUrl" type="Text" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="内容" prop="Content" v-if="editForm.IsVide==0">
                    <el-input v-model="editForm.Content" type="Text" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="关联产品" prop="ProductId" v-if="editForm.IsVide==1">
                    <selectProduct style="width: 100%" v-model="editForm.ProductId"></selectProduct>
                </el-form-item>
                <el-form-item label="状态" prop="Enabled">
                    <el-radio-group v-model="editForm.Enabled">
                        <el-radio :label="true" checked>启用</el-radio>
                        <el-radio :label="false">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="Sort">
                    <el-input v-model="editForm.Sort" type="number" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getPBVideManagePageList,PostPBVideManage,removePBVideManage} from '../../../api/api';
    import selectProduct from "../PB_TypeBanner/selectProduct.vue"
    export default {
        components:{
            selectProduct
        },
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:30,
                listLoading: false,
                data:[],
                
                //修改
                editFormVisible:false,  //窗口是否显示
                editLoading:false,   //loading显示
                editForm:{
                    Id: 0,
                    Enabled:0,
                    Title:'',
                    Content:'',
                    FirstPng:null,
                    FirstPngUrl:null
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入", trigger: "blur" }],
                    ProductId: [{ required: true, message: "请选择关联产品", trigger: "change" }],
                    BrandType:[{ required: true, message: "请输入", trigger: "blur" }]
                },
                IocimgList:[],
                firtimgList:[],

                //所有二级分类
                TypeList:[],

                IsAdd:true  //是否
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },
            firtImageChange(val)
            {
                this.firtimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'FirstPng',null);
                }   
            },
            getPBVideManagePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getPBVideManagePageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getPBVideManagePageList();
            },
            load(tree, treeNode, resolve) {
                let para = {
                    page: this.page,
                    id: tree.Id,
                };
                getPermissionTreeTable(para).then((res) => {
                    resolve(res.data.response);
                });
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.getPBVideManagePageList();
            },
            //删除
            handledel(row)
            {
                console.log(row);
                 this.$confirm("确认删除该首页轮播图吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    removePBVideManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getPBVideManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = { 
                    Id: 0,
                    Enabled:0,
                    Title:'',
                    Content:'',
                    FirstPng:null,
                    FirstPngUrl:null,
                    ProductId:null
                };
                this.firtimgList =[];
                this.IsAdd = true;
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = row;
                this.firtimgList = row.FirstPngUrl?[{url: row.FirstPngUrl}]:[];
                this.IsAdd = false;
                this.editFormVisible=true;
            },
            editSubmit() {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            const formData = new FormData();
                            if (this.firtimgList) {
                                let imgFil = this.firtimgList.filter((s) => s.status == "ready");
                                if (imgFil != null) {
                                    imgFil.forEach((it, index) => {
                                        formData.append("formFirtImgs", it.raw);
                                    });
                                }
                            }
                            formData.append("model", JSON.stringify(para));
                            PostPBVideManage(formData).then((res) => {
                                this.editLoading = false;
                                if (res.data.success) {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.editFormVisible = false;
                                    this.getPBVideManagePageList();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    } else {
                        return true;
                    }

                })

            }
     
        },
        mounted() {
            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getPBVideManagePageList();
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
